export default __webpack_public_path__ + "static/project6-d78355683f24f2d1b20fc07a3a9c8618.jpg";